import { Component } from "react"
import PropTypes from "prop-types"
import SolutionLottieAnimation from "./solution_lottie_animation"

export default class InformationAnimation extends Component {
  render() {
    const { lottieJson } = this.props

    return (
      <SolutionLottieAnimation
        animationId="information-animation"
        lottieJson={lottieJson}
      />
    )
  }
}

InformationAnimation.propTypes = {
  lottieJson: PropTypes.string.isRequired,
}
